import '../scss/product.scss';
import { mountSlider } from '../components/product-slider';
import { $Q } from '../utils/query-selector';
import '../components/tags';
import { hoverOnZoom } from '../components/hover-zoom';

import { toggleDataActive } from '../utils/toggle-dataset';
import { copyURLStore, shareProduct } from '../components/copy-text';
import { mediaQuery } from '../utils/media-query';
import { trigger, zoomSwipe } from '../components/zoom-swipe';
import { submitPlusPhotos } from '../components/plus-photo';
import { initializeMesAlertsMethods } from '../components/mes-alerts';
import { lazyLoad } from '../utils/lazy-load';

mountSlider($Q('.swiper.main-product__slider-principal'));
hoverOnZoom();


toggleDataActive(
  '#js-360-image',
  '#js-view-360-img-modal',
  { overlay: true, blockScroll: true },
);


mediaQuery('(min-width: 992px)', copyURLStore);
mediaQuery('(max-width: 991px)', shareProduct);


toggleDataActive('#js-certified-modal-open', '#js-certified-modal', {
  overlay: true,
  closeSelector: '#js-certified-modal-close',
  blockScroll: true,
});


toggleDataActive('#js-btn-photo-plus-open', '#js-plus-photo-modal', {
  overlay: true,
  closeSelector: '#js-plus-photo-modal-close',
  blockScroll: true,
  type: 'plus-photo'
});

lazyLoad($Q('#js-btn-mes-alets-open'), (observe) => {
  initializeMesAlertsMethods()
  observe.disconnect()
}, {
  rootMargin: '20px',
  threshold: 0,
})

lazyLoad($Q('#js-btn-photo-plus-open'), (observe) => {
  submitPlusPhotos()
  observe.disconnect()
}, {
  rootMargin: '20px',
  threshold: 0,
})

window.addEventListener('load', () => {
  toggleDataActive('#js-condition-modal-open', '#js-condition-modal', {
    overlay: true,
    closeSelector: '#js-condition-modal-close',
    blockScroll: true,
  });

  toggleDataActive('#js-shoulder-strap-modal-open', '#js-shoulder-strap-modal', {
    overlay: true,
    closeSelector: '#js-shoulder-strap-modal-close',
    blockScroll: true,
  });

  
    zoomSwipe();
    trigger();
})





